import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { useCallback } from 'react';
import { componentOnly } from '@beef/react/utils';
import { combineRefs } from '@carnica/utils';
/**
 * Прокидывает в дочерний элемент ref для отслеживания его появления
 */
export var ChildrenRefObserver = function ChildrenRefObserver(_ref) {
  var children = _ref.children,
    elementsRef = _ref.elementsRef,
    _ref$refName = _ref.refName,
    refName = _ref$refName === void 0 ? 'ref' : _ref$refName;
  var onlyElementRef = useCallback(function (el) {
    elementsRef === null || elementsRef === void 0 ? void 0 : elementsRef(el ? [el] : []);
  }, [elementsRef]);
  if (React.Children.count(children) > 1) {
    React.Children.only(children);
    return children || null;
  }
  return React.Children.map(children, componentOnly(function (child) {
    return /*#__PURE__*/React.cloneElement(child, _defineProperty({}, refName, combineRefs([child.props[refName], onlyElementRef])));
  }));
};